import { render } from "./TaskHall.vue?vue&type=template&id=1acd4e80&ts=true"
import script from "./TaskHall.vue?vue&type=script&lang=ts"
export * from "./TaskHall.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__